<template src='./create-system-users.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import { EventBus } from '@/router/bus'
import ErrorPanel from '@/components/error-panel/ErrorPanel'
import VuePapaParse from 'vue-papa-parse'

Vue.use(VuePapaParse)

export default {
  components: {
    ContextPage,
    ErrorPanel
  },
  filters: {
    kb (val) {
      return Math.floor(val / 1024)
    }
  },
  data () {
    return {
      formValid: true,
      roleId: null,
      roles: [],
      loading: false,
      file: false,
      loadedFile: '',
      dragging: false,
      errorList: [],
      successMessage: '',
      errorMessage: '',
      parsedFile: {},
      dropzoneOptions: {
        acceptedFiles: ['.csv'],
        defaultMessage: 'Превуците датотеку'
      },
      roleRules: [
        v => !!v || this.$t('validation.roleRequired')
      ],
      alertShow: false,
      alertType: 'error',
      alertText: ''
    }
  },
  created () {
    this.loading = true
    this.dropzoneOptions.defaultMessage = this.$t('dropzone.defaultMessage')
    // add api get request to roles and groups, localRoles and groups are muck for now
    this.$http.get(Vue.$apiConfig.getAllUserRoles).then(
      response => {
        response.data.payload.forEach((role) => {
          this.roles.push({ text: this.$t('roles.' + role.name), value: role.id })
        })
        this.loading = false
      },
      error => {
        this.formatErrorResponse(error)
        this.logConsole(error)
        this.roles.push({ text: this.$t('general.noDataAvailable'), value: 0 })
        this.loading = false
      }
    )
  },
  methods: {
    addFile (e) {
      const droppedFiles = e.target.files || e.dataTransfer.files
      if (!droppedFiles) {
        // dont know how this happened
        return
      }
      if (droppedFiles.length > 1) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('dropzone.tooManyFiles')
        })
        return
      }
      if (!this.dropzoneOptions.acceptedFiles.includes('.' + droppedFiles[0].name.split('.').pop())) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('dropzone.unsupportedFile')
        })
        return
      }
      this.file = droppedFiles[0]
      this.$refs.fileUpload.value = ''
      const reader = new FileReader()
      reader.onload = (e) => {
        this.loadedFile = e.target.result
        this.dropzoneSuccess()
      }
      reader.readAsText(this.file)
    },
    dropzoneSuccess () {
      this.parsedFile = this.$papa.parse(this.loadedFile)
      const systemUsers = []

      if (this.parsedFile.data === undefined || this.parsedFile.data.length === 0) {
        this.file = null
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('systemUsers.importSystemUsersEmptyData')
        })
      } else {
        this.parsedFile.data.forEach((systemUser) => {
          var obj = {}
          obj.name = systemUser[0] ? systemUser[0].trim() : ''
          obj.login = systemUser[1] ? systemUser[1].trim() : ''
          obj.roleId = this.roleId
          systemUsers.push(obj)
        })
        this.parsedFile.data = systemUsers
        this.errorList = this.parseFileErrors(systemUsers)
      }
    },
    dropzoneFailure (file, errorMessage, xhr) {
      this.loading = false
      EventBus.$emit('alert', {
        variant: 'error',
        message: errorMessage
      })
    },
    loadSystemUsers () {
      if (!this.$refs.form.validate()) {
        return
      }

      if (this.errorList.length > 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('systemUsers.validationImport'),
          errors: []
        })
        return
      }
      this.errorList = []
      if (this.parsedFile.data === undefined || this.parsedFile.data.length === 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('systemUsers.importSystemUsersEmptyData'),
          errors: []
        })
      } else {
        this.loading = true
        this.$http.post(Vue.$apiConfig.createSystemUserPost, this.parsedFile.data)
          .then(response => {
            this.logConsole(response)
            const currentResponse = response.data.payload
            var atLeastOneSuccessfull = false
            if (currentResponse !== null && currentResponse.length > 0) {
              for (let i = 0; i < currentResponse.length; i++) {
                if (currentResponse[i].error !== null) {
                  const errorItem = { index: i + 1, text: this.$t('apiStatusCodes.' + currentResponse[i].error.code) }
                  errorItem.text += ' : ' + currentResponse[i].name + ' ' + currentResponse[i].login
                  this.errorList.push(errorItem)
                } else {
                  atLeastOneSuccessfull = true
                }
              }
            }

            if (atLeastOneSuccessfull) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('systemUsers.importSystemUsersSuccess')
              })
            }

            this.loading = false
          }, error => {
            this.logConsole(error)
            this.loading = false
            const currentResponse = error.data.payload
            let errorMessage
            if (error.status === 422) {
              const errorHash = {}
              for (let i = 0; i < currentResponse.length; i++) {
                const field = currentResponse[i].field
                if (field) {
                  const messageIndex = parseInt(field.substring(field.lastIndexOf('[') + 1, field.lastIndexOf(']'))) + 1
                  if (!errorHash[messageIndex]) { errorHash[messageIndex] = '' }
                  errorHash[messageIndex] += this.$t('apiStatusCodes.' + currentResponse[i].code) + '; '
                }
              }
              for (var key in errorHash) {
                this.errorList.push({ index: key, text: errorHash[key] })
              }
              errorMessage = this.$t('errors.someErrorsOccuredCheckListBelow')
            } else if (error.status === 429) {
              errorMessage = this.$t('invoiceLimitExceeded')
            } else {
              if (currentResponse !== null && currentResponse.length > 0) {
                for (let i = 0; i < currentResponse.length; i++) {
                  if (currentResponse[i].error !== null) {
                    const errorItem = { index: i + 1, text: this.$t('apiStatusCodes.' + currentResponse[i].error.code) }
                    errorItem.text += ' : ' + currentResponse[i].login
                    this.errorList.push(errorItem)
                  }
                }
              }
              errorMessage = this.$t('apiStatusCodes.' + error.data.status.code)
            }
            EventBus.$emit('alert', {
              variant: 'error',
              message: errorMessage
            })
          })
      }
    },
    roleSelected (roleId) {
      if (this.parsedFile.data && this.parsedFile.data.length > 0) {
        this.parsedFile.data.forEach((systemUser) => {
          systemUser.roleId = roleId
        })
      }
    },
    parseFileErrors (systemUsers) {
      const errorMessages = []

      const isDuplicate = []
      systemUsers.forEach((user, index) => {
        const lineErrors = []

        if (!user.name) {
          lineErrors.push(this.$t('validation.userNameEmpty'))
        } else if (!/^[A-Za-z0-9- ]+$/.test(user.name)) {
          lineErrors.push(this.$t('validation.userNameFormat'))
        }

        if (!user.login) {
          lineErrors.push(this.$t('validation.emailEmpty'))
        } else if (!/.+@.+\..+/.test(user.login)) {
          lineErrors.push(this.$t('validation.emailFormat'))
        } else if (typeof isDuplicate[user.login] !== 'undefined') {
          lineErrors.push(this.$t('validation.duplicateEmail'))
        } else {
          isDuplicate[user.login] = true
        }

        if (lineErrors.length > 0) {
          errorMessages.push({ index: index + 1, text: lineErrors.join('; ') })
        }
      })

      return errorMessages
    }
  }
}
</script>

<style scoped>
  .v-label {
    font-size: 15px !important;
  }
  .v-input__slot {
    margin-bottom: 0px !important;
  }
  .v-card__text {
    font-size: 20px;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  #file-input {
    display: none;
  }
  .file-label {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 300px;
    /* p.text {
      margin: auto;
    }
    p.icon {
      margin: 0px auto 50px;
    } */
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
